import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

const STORAGE_KEY = 'envSignedIn';
const VALID_EMAIL = 'gaurav@maukaa.io';
const VALID_PASSWORD = 'Gaurav1234';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss'],
})
export class LoginPopupComponent implements OnInit {
  visible = false;
  email = '';
  password = '';
  errorMessage = '';
  showPassword = false;

  ngOnInit(): void {
    if (environment.loginPermission && localStorage.getItem(STORAGE_KEY) !== 'true') {
      this.visible = true;
    }
  }

  onSubmit(): void {
    if (this.email === VALID_EMAIL && this.password === VALID_PASSWORD) {
      localStorage.setItem(STORAGE_KEY, 'true');
      this.visible = false;
      this.errorMessage = '';
    } else {
      this.errorMessage = 'Invalid email or password.';
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
